import { Menu } from 'lucide-react';

/**
 * Preview skin for the membership app's Access page (`access.body`): the
 * chrome that surrounds the slot in the real app — the club-perks hero
 * background with its top fade, and the Nav bar (hamburger, "Welcome back"
 * greeting, avatar). Classes are copied from the app's Access page and Nav;
 * everything is a static, inert lookalike ("Alex" stands in for the viewing
 * member's first name, the placeholder avatar for their photo).
 */
export default function AccessSkin({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative">
      <div className="relative">
        <img
          src="/club-perks.jpg"
          alt=""
          className="absolute inset-0 z-0 max-h-125 w-full object-cover"
        />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-24 bg-linear-to-b from-black via-black/90 to-transparent" />
      </div>

      <div className="relative flex w-full items-center p-4">
        <div className="size-12 shrink-0 p-2 text-[#caab6a]">
          <Menu size={32} />
        </div>
        <div className="flex h-full flex-1 items-center justify-center text-center">
          <div className="text-base font-normal text-white">
            Welcome back, Alex
          </div>
        </div>
        <div className="mx-2 size-12 shrink-0">
          <img
            src="/profile-placeholder.jpg"
            alt=""
            className="h-full w-full rounded-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pt-32">{children}</div>
    </div>
  );
}
